export default {
  autoCompleteType: {
    destination: 'Par destination',
    line: 'Par ligne',
  },
  tabs: {
    delivery: 'Livraison',
    shuttle: 'Navette',
    taxi: 'Taxi',
    airport: 'Aéroport',
  },
  formDestination: {
    from: 'De',
    to: 'À',
    date: 'Date & Heure',
    returnDate: 'Heure de retour',
  },
  formLine: {
    area: 'Secteur',
    shuttles: 'Lignes',
    direction: 'Direction',
    date: 'Date',
    pickup: 'Arrêt d\'embarquement',
    pickUpTime: 'Heure',
    dropoff: 'Arrêt de débarquement',
    dropOffTime: 'Heure',
    btnSubmit: 'Réserver',
    departingFrom: 'Au départ de {{stop}}',
    arrivingAt: 'Arrivée à {{stop}}',
    departureTime: 'Heure de départ',
    arrivalTime: 'Heure d\'arrivée',
  },
  passenger: 'Passager',
  passengers: 'Passagers',
  btnFindServices: 'Chercher',

  days: '+{{days}}J',

  message: 'Cette ligne est disponible pour les heures suivantes {{times}} Veuillez s\'il vous plait spécifier une heure existante',
};
